var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"i-con"},[_c('span',{attrs:{"id":_vm.idName}},[_vm._v(_vm._s(_vm.startVal))]),_c('span',[_vm._v(_vm._s(_vm.unit))])]),_vm._t("intro")],2)}
var staticRenderFns = []

export { render, staticRenderFns }